import { frontendURL } from '../../../helper/URLHelper';
import AgentMonitorWrapper from './AgentMonitorWrapper.vue';
import AgentMonitorBoard from './components/AgentMonitorBoard.vue';

const meta = {
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/agent-monitor'),
      component: AgentMonitorWrapper,
      children: [
        {
          path: '',
          name: 'agent_monitor',
          meta,
          component: AgentMonitorBoard,
        },
      ],
    },
  ],
};
